import React from "react";

export default function ToTop() {
  return (
    <div className="uk-width-1-1 uk-text-right">
      <a href="#" data-uk-totop data-uk-scroll />
    </div>
  );
}
